import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const ClaimsCostCategory = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default ClaimsCostCategory;
